import { NavigationPanel } from "components/navigationPanel/NavigationPanel";
import { useState } from "react";
import { designTokens } from "theme/customTheme";
import { MyChats } from "components/myChats/MyChats";

const styles = {
  container: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
  } as React.CSSProperties,
  navPanel: {
    display: "flex",
    flexShrink: 0,
    height: "100vh",
    backgroundColor: designTokens.neutral[50],
  } as React.CSSProperties,
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minWidth: 0,
    height: "100vh",
    boxSizing: "border-box",
    overflow: "hidden",
  } as React.CSSProperties,
};

export const MyChatsPage = (): JSX.Element => {
  return (
    <div className="App" style={styles.container}>
      <div style={styles.navPanel}>
        <NavigationPanel />
      </div>
      <div style={styles.contentContainer}>
        <MyChats />
      </div>
    </div>
  );
};
